import { useSpeakToExpertModalConfig } from '@/components/app/speak-to-expert-modal/useSpeakToExpertModalConfig'

export function useSpeakToExpertModal(): { open: () => void } {
    const { open } = useSpeakToExpertModalConfig()

    return { open }
}
